import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService           from 'FactoryService.js';
import constants                from 'Constants.js';
import sequenceService          from 'SequenceService.js';
import ControlModel    from 'ControlModel.js';
import DataControlView      from 'report/DataControlView.js';
import listService from 'ListService';


class ControlDataGridFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        attributes.dataSourceId = 'null';
        //adding silent(accessibility) to attributes.
		    attributes.silent = false;
		    //attributes.caption = 'Button';
		    //attributes.borderStyle = 'solid';

		    //attributes.buttonStyle ='~buttonStyle';
        attributes.styleColorText ='#000000';
		    //attributes.styleColorTextDown ='~buttonTextDownColor';
		    //attributes.styleColorTextOver ='~buttonTextOverColor';


        // Rows
        attributes.fontFamily =  listService.accountSettings.DefaultFontSelected || "verdana";
        attributes.fontSize = '10';
        attributes.textWeight = '';
        attributes.textStyle  = '';

        attributes.headerTextColor ='#000000';
        attributes.headerFontFamily =  listService.accountSettings.DefaultFontSelected || "verdana";
        attributes.headerFontSize = '10';
        attributes.headerTextWeight = '';
        attributes.headerTextStyle  = '';

        attributes.normalRowBgColor = '~buttonBgColor';
        attributes.alternateRowBgColor = '~buttonBgGradientColor';

        attributes.headerBgColor = '~tableHeaderBgColor';
        attributes.normalRowBgColor = '~tableRowColor1';
        attributes.alternateRowBgColor = '~tableRowColor2';
        attributes.headerBoldSelection = 'transparent';
        attributes.headerItalicSelection = 'transparent';

        attributes.height = 200;
        attributes.rowHeight = 25;
        attributes.maxRows = 10;
        attributes.variableRowHeight = 'false';
        attributes.headerHeight = 20;
        attributes.bodyHeight = 140;
        attributes.showNavButtons = true;
        attributes.showNavButtonsHide = '';
        attributes.showDsInfo = true;
        attributes.showDsInfoHide = '';
        attributes.allowExport = false;
        attributes.allowExportHide = 'hidden';

        attributes.numberDecimals = 2;
        attributes.numberSymbol = '';
        attributes.numberDecimalSeparator = '.';
        attributes.numberThousandSeparator = ',';
        attributes.dateFormat = 'MM.DD.YYYY';
        attributes.time24Hour = '';
        attributes.timeShowSeconds = '';
        attributes.booleanYes = '';
        attributes.booleanNo = '';
        attributes.percentageDecimals = 2;      

        attributes.setFilter = 'checked';
        attributes.overridePrevious = '';
        attributes.respectDynamicFilter = 'checked';
        attributes.showAllValues = '';
        attributes.linksNewWindow = 'true'; 
        attributes.description = '';

        attributes.hasAggregate = true;
        attributes.columnAggregate = 'Group';
        attributes.columnFieldId = 'none';
        attributes.columnSort =  'none';
        attributes.columnWidth = 150;
        attributes.columnHidden = '';
        attributes.columnAlign = 'left';
        attributes.columnIncludeFilter = '';
        attributes.columnFormat = 'none';
      
        attributes.gridData = [];
        attributes.resizePadding = 2;
        attributes.Columns = { Column: [] };
		    attributes.minWidth = 280;
		    attributes.minHeight = 150;
            attributes.lowestHeight = 150;
        
        attributes.additiveDynamicFilter = 'false'; 
        attributes.setDynamicFilter = 'true'; 
        attributes.respectDynamicFilter = 'true'; 
        attributes.sortOrder = ''; 
        attributes.ignoreNull = 'false'; 

        const view = new DataControlView( { 
            model: new ControlModel( attributes ),
            el: $(constants.FORM_ID),
            pos: pos, 
            factoryKey: factoryKey, 
            id: attributes.id
        });

        console.log(view.model.attributes);

        return view;
    }

}

const controlDataGridFactory = new ControlDataGridFactory();

export default controlDataGridFactory;